import React, { PureComponent } from 'react'
import Layout from '../../components/Layout'
import Hero from '../../components/Hero'
import Section from '../../components/Section'
import Wrapper from '../../components/Wrapper'
import Type, { P, BulletList, ListItem } from '../../components/Type'

import { injectIntl, defineMessages } from 'gatsby-plugin-intl'
import { track as trackEvent } from '../../global/analytics'
import eventConstants from '../../global/eventConstants'

export const messageDescriptors = defineMessages({
  title: {
    id: 'pages.legal.health.title',
    defaultMessage: 'UNROLL.ME CONSUMER HEALTH DATA PRIVACY NOTICE',
  },
  paragraph1: {
    id: 'pages.legal.health.paragraph1',
    defaultMessage: 'April 14, 2025',
  },
  paragraph2A1: {
    id: 'pages.legal.health.paragraph2A1',
    defaultMessage:
      'This Consumer Health Data Privacy Notice ("',
  },
  paragraph2A2: {
    id: 'pages.legal.health.paragraph2A2',
    defaultMessage:
      'CHD Notice',
  },
  paragraph2A3: {
    id: 'pages.legal.health.paragraph2A3',
    defaultMessage:
      '") supplements the Unrollme LLC (“Unroll.Me,” ',
  },
  paragraph2A4: {
    id: 'pages.legal.health.paragraph2A4',
    defaultMessage:
      'we',
  },
  paragraph2A5: {
    id: 'pages.legal.health.paragraph2A5',
    defaultMessage:
      ',” “',
  },
  paragraph2A6: {
    id: 'pages.legal.health.paragraph2A6',
    defaultMessage:
      'our',
  },
  paragraph2A7: {
    id: 'pages.legal.health.paragraph2A7',
    defaultMessage:
      ',” or “',
  },
  paragraph2A8: {
    id: 'pages.legal.health.paragraph2A8',
    defaultMessage:
      'us',
  },
  paragraph2A9: {
    id: 'pages.legal.health.paragraph2A9',
    defaultMessage:
      '”) ',
  },
  paragraph2B: {
    id: 'pages.legal.health.paragraph2B',
    defaultMessage: 'Privacy Notice',
  },
  paragraph2C1: {
    id: 'pages.legal.health.paragraph2C1',
    defaultMessage:
      ' (“',
  },
  paragraph2C2: {
    id: 'pages.legal.health.paragraph2C2',
    defaultMessage:
      'Privacy Notice',
  },
  paragraph2C3: {
    id: 'pages.legal.health.paragraph2C3',
    defaultMessage:
      '”) and applies to “',
  },
  paragraph2C4: {
    id: 'pages.legal.health.paragraph2C4',
    defaultMessage:
      'consumer health data',
  },
  paragraph2C5: {
    id: 'pages.legal.health.paragraph2C5',
    defaultMessage:
      '” (“',
  },
  paragraph2C6: {
    id: 'pages.legal.health.paragraph2C6',
    defaultMessage:
      'CHD',
  },
  paragraph2C7: {
    id: 'pages.legal.health.paragraph2C7',
    defaultMessage:
      '”), as defined by the Washington State My Health My Data Act (“',
  },
  paragraph2C8: {
    id: 'pages.legal.health.paragraph2C8',
    defaultMessage:
      'WMHMDA',
  },
  paragraph2C9: {
    id: 'pages.legal.health.paragraph2C9',
    defaultMessage:
      '”), Nevada’s Consumer Health Data Privacy Law, and other similar U.S. health data privacy laws (collectively, “',
  },
  paragraph2C10: {
    id: 'pages.legal.health.paragraph2C10',
    defaultMessage:
      'health data privacy laws',
  },
  paragraph2C11: {
    id: 'pages.legal.health.paragraph2C11',
    defaultMessage:
      ' (collectively, “health data privacy laws”). Where there are differences between this CHD Notice and our Privacy Notice, this CHD Notice governs.',
  },
  paragraph3A: {
    id: 'pages.legal.health.paragraph3A',
    defaultMessage: 'As described in our ',
  },
  paragraph3B: {
    id: 'pages.legal.health.paragraph3B',
    defaultMessage: 'Privacy Notice',
  },
  paragraph3C: {
    id: 'pages.legal.health.paragraph3C',
    defaultMessage:
      ', the data we collect varies and depends, among other things, on the context of your interactions with us, the products and features you use, and applicable law. Some of the categories of data we collect could be considered CHD under the health data privacy laws.',
  },
  paragraph4: {
    id: 'pages.legal.health.paragraph4',
    defaultMessage:
      'Below are examples of the categories of data that could be deemed CHD, which we collect from commercial emails in an email account you authorize us to access and process:',
  },

  list1Point1: {
    id: 'pages.legal.health.list1Point1',
    defaultMessage:
      'Information about your health-related conditions, symptoms, status, diagnoses, procedures, testing, medications, or treatments. For example, we may collect such information when it’s associated with a product you purchase.',
  },
  list1Point2: {
    id: 'pages.legal.health.list1Point2',
    defaultMessage:
      'Information that could be related to reproductive or sexual health, such as details about services you subscribe to.',
  },
  list1Point3: {
    id: 'pages.legal.health.list1Point3',
    defaultMessage:
      'Information that could identify your attempt to seek health care services or information, including services that allow you to assess, measure, improve, or learn about your or another person’s health based on your email receipts.',
  },
  list1Point4: {
    id: 'pages.legal.health.list1Point4',
    defaultMessage:
      'Information that could associate you with a category of CHD that is derived or extrapolated from information such as when our data models (the framework in how we organize data) use the information detailed above to infer, examine, and make predictions that may reflect an individual’s preferences, characteristics, trends, behaviors, and actions. For example, if your transactions indicate you reside in a general geographic area, our systems might associate you with certain health-related conditions prevalent in that area based on census or demographic data, such as skin cancers in regions closer to the equator.',
  },

  paragraph5: {
    id: 'pages.legal.health.paragraph5',
    defaultMessage: 'Sources of Consumer Health Data',
  },
  paragraph6: {
    id: 'pages.legal.health.paragraph6',
    defaultMessage:
      'We collect CHD directly from the email inbox(es) that you authorize us to access.',
  },
  paragraph7: {
    id: 'pages.legal.health.paragraph7',
    defaultMessage: 'Why We Collect and Use Consumer Health Data',
  },
  paragraph8A: {
    id: 'pages.legal.health.paragraph8A',
    defaultMessage: 'We collect and use CHD for the purposes described in our ',
  },
  paragraph8B: {
    id: 'pages.legal.health.paragraph8B',
    defaultMessage: 'Privacy Notice',
  },
  paragraph8C: {
    id: 'pages.legal.health.paragraph8C',
    defaultMessage:
      '. More specifically, we collect and use information that could be considered CHD for the following purposes:',
  },

  list2Point1: {
    id: 'pages.legal.health.list2Point1',
    defaultMessage:
      'To perform the functions of the services you request or authorize, such as blocking you from unwanted subscription emails and creating a “roll-up” of other subscriptions and/or transactions; authenticating you as part of our security processes; developing and offering new services; and tailoring content as part of our service such as in our roll-up summaries.',
  },
  list2Point2: {
    id: 'pages.legal.health.list2Point2',
    defaultMessage:
      'As reasonably necessary to provide the services and operate our business. This may include providing users with access to our website, mobile application, services, or features; developing, delivering, and operating the services and their features; responding to your communications; better understanding our users and their interests and preferences; tailoring certain features of the services; ensuring the secure and reliable operation of the systems that support the services; troubleshooting and improving the services; and other essential business operations that support the provision of the services.',
  },
  list2Point3: {
    id: 'pages.legal.health.list2Point3',
    defaultMessage:
      'For any purpose for which you consent, authorize, or direct us to collect or use it.',
  },

  paragraph9A: {
    id: 'pages.legal.health.paragraph9A',
    defaultMessage:
      'We may use CHD for other purposes for which we will give you choices and/or obtain your consent as required by law. See the “Privacy Rights and Choices” section below and within our ',
  },
  paragraph9B: {
    id: 'pages.legal.health.paragraph9B',
    defaultMessage: 'Privacy Notice',
  },
  paragraph9C: {
    id: 'pages.legal.health.paragraph9C',
    defaultMessage: ' for more details on the rights and choices you may have.',
  },
  paragraph10A: {
    id: 'pages.legal.health.paragraph10A',
    defaultMessage:
      'For transparency purposes:',
  },
  paragraph10B: {
    id: 'pages.legal.health.paragraph10B',
    defaultMessage:
      ' We do not use your name, address, or any directly identifiable information you provide to us for direct marketing or sales purposes to you. We never share this identifiable information with telemarketers, nor do we permit our business customers to use it for direct marketing or sales to you.',
  },
  paragraph11: {
    id: 'pages.legal.health.paragraph11',
    defaultMessage: 'Consumer Health Data We Share',
  },
  paragraph12: {
    id: 'pages.legal.health.paragraph12',
    defaultMessage:
      'We may share each of the categories of CHD described above for the following purposes:',
  },

  list3Point1: {
    id: 'pages.legal.health.list3Point1',
    defaultMessage:
      'For enhancing our and our affiliates’ measurement capabilities by combining the information that we collect with other information available to them.',
  },
  list3Point2: {
    id: 'pages.legal.health.list3Point2',
    defaultMessage:
      'To the extent necessary to provide a service that you have requested or as reasonably necessary to complete any transaction or provide any product or service you have requested or authorized.',
  },
  list3Point3: {
    id: 'pages.legal.health.list3Point3',
    defaultMessage:
      'If we are involved in a merger, asset sale, financing, corporate divesture, reorganization, or acquisition of all or some portion of our business to another company or if we undergo liquidation or bankruptcy proceedings, we may disclose your information in connection with such transaction or proceeding before and or after the transaction closes or the proceedings are completed.',
  },
  list3Point4: {
    id: 'pages.legal.health.list3Point4',
    defaultMessage:
      'For any purpose for which you consent, authorize, or direct us to disclose it.',
  },
  list3Point5: {
    id: 'pages.legal.health.list3Point5',
    defaultMessage:
      'We may disclose data when we believe that doing so is necessary to comply with applicable law or respond to valid legal process, or when we believe disclosure is necessary or appropriate to prevent physical harm or financial loss in connection with an investigation of suspected or actual illegal activity, or if necessary to protect the vital interests of another individual.',
  },

  paragraph13: {
    id: 'pages.legal.health.paragraph13',
    defaultMessage:
      'We do not exchange information that could be considered your CHD with third parties for monetary or other valuable consideration. To the extent permitted under applicable law, we may deidentify or aggregate CHD so that it will no longer be considered CHD. Our use and disclosure of deidentified or aggregated information is not governed by this CHD Notice.',
  },
  paragraph14A: {
    id: 'pages.legal.health.paragraph14',
    defaultMessage:
      'As a reminder',
  },
  paragraph14B: {
    id: 'pages.legal.health.paragraph14',
    defaultMessage:
      ', we do not use your name, address, or any directly identifiable information you provide to us for direct marketing or sales purposes to you. We never share this identifiable information with telemarketers, nor do we permit our business customers to use it for direct marketing or sales to you.',
  },
  paragraph15: {
    id: 'pages.legal.health.paragraph15',
    defaultMessage: 'Third Parties with Whom We Share Consumer Health Data',
  },
  paragraph16: {
    id: 'pages.legal.health.paragraph16',
    defaultMessage:
      'As necessary for the purposes described in the section “Consumer Health Data We Share,” we disclose information that could be considered CHD with the following categories of third parties:',
  },

  list4Point1A: {
    id: 'pages.legal.health.list4Point1A',
    defaultMessage:
      'Affiliates',
  },
  list4Point1B: {
    id: 'pages.legal.health.list4Point1B',
    defaultMessage:
      '. We enable access to data across our subsidiaries, affiliates, and related companies, for example, where we utilize common data systems or where access helps us to provide our services and operate our business. Unroll.Me belongs to the group of companies listed ',
  },
  list4Point1C: {
    id: 'pages.legal.health.list4Point1C',
    defaultMessage: 'here',
  },
  list4Point1D: {
    id: 'pages.legal.health.list4Point1D',
    defaultMessage: ' and ',
  },
  list4Point1E: {
    id: 'pages.legal.health.list4Point1E',
    defaultMessage: 'here',
  },
  list4Point1F: {
    id: 'pages.legal.health.list4Point1F',
    defaultMessage: ', which together form the ',
  },
  list4Point1G: {
    id: 'pages.legal.health.list4Point1G',
    defaultMessage: '"NIQ Group."',
  },
  list4Point2A: {
    id: 'pages.legal.health.list4Point2A',
    defaultMessage:
      'Government, regulatory, and public authorities',
  },
  list4Point2B: {
    id: 'pages.legal.health.list4Point2B',
    defaultMessage:
      '. As described in our ',
  },
  list4Point2C: {
    id: 'pages.legal.health.list4Point2C',
    defaultMessage: 'Privacy Notice',
  },
  list4Point2D: {
    id: 'pages.legal.health.list4Point2D',
    defaultMessage:
      ', we disclose data to law enforcement or other government agencies when we believe doing so is necessary to comply with applicable law or respond to valid legal process.',
  },
  list4Point3A: {
    id: 'pages.legal.health.list4Point3A',
    defaultMessage:
      'Parties to a corporate transaction.',
  },
  list4Point3B: {
    id: 'pages.legal.health.list4Point3B',
    defaultMessage:
      ' We may disclose information that might be considered CHD as part of a corporate transaction or proceeding such as a merger, financing, acquisition, bankruptcy, dissolution, or a transfer, divestiture, or sale of all or a portion of our business or assets.',
  },
  list4Point4A: {
    id: 'pages.legal.health.list4Point4A',
    defaultMessage:
      'Other third parties.',
  },
  list4Point4B: {
    id: 'pages.legal.health.list4Point4B',
    defaultMessage:
      ' In certain circumstances, it may be necessary to provide data to other third parties, for example, to comply with the law or to protect our rights or those of our customers. We may also disclose CHD, as directed by you in order to provide the services or product you request. To the extent we share your CHD with other third parties, we will do so in accordance with health data privacy laws.',
  },

  paragraph17: {
    id: 'pages.legal.health.paragraph17',
    defaultMessage: 'Privacy Rights and Choices',
  },
  paragraph18: {
    id: 'pages.legal.health.paragraph18',
    defaultMessage:
      'If you are a consumer under the health data privacy laws and we collect, use, or share your CHD, you may have the following rights with respect to your CHD, subject to applicable exceptions.',
  },

  list5Point1A: {
    id: 'pages.legal.health.list5Point1A',
    defaultMessage:
      'Right to access.',
  },
  list5Point1B: {
    id: 'pages.legal.health.list5Point1B',
    defaultMessage:
      ' You have the right to confirm whether we are processing your CHD and to access such CHD.',
  },
  list5Point2A: {
    id: 'pages.legal.health.list5Point2A',
    defaultMessage:
      'Right to delete.',
  },
  list5Point2B: {
    id: 'pages.legal.health.list5Point2B',
    defaultMessage:
      ' You have the right to ask us to delete certain CHD we have collected about you.',
  },
  list5Point3A: {
    id: 'pages.legal.health.list5Point3A',
    defaultMessage:
      'Right to withdraw consent.',
  },
  list5Point3B: {
    id: 'pages.legal.health.list5Point3B',
    defaultMessage:
      ' If you consent to any collection or sharing of CHD, you have the right to withdraw your consent at any time.',
  },

  paragraph19A: {
    id: 'pages.legal.health.paragraph19A',
    defaultMessage:
      'You can request to exercise such rights using the methods described in the “Privacy Rights and Choices” section of our ',
  },
  paragraph19B: {
    id: 'pages.legal.health.paragraph19B',
    defaultMessage:
      'Privacy Notice',
  },
  paragraph19C: {
    id: 'pages.legal.health.paragraph19C',
    defaultMessage:
      ', including through our webform available at  ',
  },
  paragraph19D: {
    id: 'pages.legal.health.paragraph19D',
    defaultMessage: 'Your Privacy Rights',
  },
  paragraph19E: {
    id: 'pages.legal.health.paragraph19E',
    defaultMessage:
      ', also located in the footer of our website, or by emailing us at ',
  },
  paragraph19F: {
    id: 'pages.legal.health.paragraph19F',
    defaultMessage: 'privacy@unroll.me',
  },
  paragraph20A: {
    id: 'pages.legal.health.paragraph20A',
    defaultMessage:
      'If your request to exercise a right under the health data privacy laws is denied, you may appeal that decision by contacting our privacy support team at ',
  },
  paragraph20B: {
    id: 'pages.legal.health.paragraph20B',
    defaultMessage: 'privacy@unroll.me',
  },
  paragraph20C: {
    id: 'pages.legal.health.paragraph20C',
    defaultMessage:
      '. If your appeal is unsuccessful, you can raise a concern or file a complaint with the Washington State Attorney General at ',
  },
  paragraph20D: {
    id: 'pages.legal.health.paragraph20D',
    defaultMessage: 'www.atg.wa.gov/file-complaint',
  },
})

const track = (eventName, eventProps) => {
  trackEvent(eventName, {
    ...eventProps,
    Page: eventConstants.privacy.pageName,
  })
}

class Privacy extends PureComponent {
  constructor(props) {
    super(props)
    this.restrictions = React.createRef()
  }

  componentDidMount() {
    if (window.location.hash === '#restrictions') {
      setTimeout(() => {
        window.scrollTo(0, this.restrictions.current.offsetTop)
      }, 0.001)
    }
    track(eventConstants.privacy.pageLoad)
  }

  render() {
    // TODO: fix internationlization, currently brokens
    // const { intl } = this.props
    // const messages = Object.keys(messageDescriptors).reduce((messages, key) => {
    //   messages[key] = intl.formatMessage(messageDescriptors[key])
    //   return messages
    // }, {})

    const messages = Object.keys(messageDescriptors).reduce((messages, key) => {
      messages[key] = messageDescriptors[key].defaultMessage
      return messages
    }, {})

    return (
      <Layout title={messages.title}>
        <Hero>
          <Section large>
            <Wrapper tc small>
              <Type variant="h1" f1_ns lh_copy dark_gray mb0>
                {messages.title}
              </Type>
            </Wrapper>
          </Section>
          <Section large>
            <Wrapper small lh_copy>
              <P>{messages.paragraph1}</P>

              <P>
                {messages.paragraph2A1}
                <b>{messages.paragraph2A2}</b>
                {messages.paragraph2A3}
                <b>{messages.paragraph2A4}</b>
                {messages.paragraph2A5}
                <b>{messages.paragraph2A6}</b>
                {messages.paragraph2A7}
                <b>{messages.paragraph2A8}</b>
                {messages.paragraph2A9}
                <a
                  href="https://unroll.me/legal/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph2B}
                </a>
                {messages.paragraph2C1}
                <b>{messages.paragraph2C2}</b>
                {messages.paragraph2C3}
                <b>{messages.paragraph2C4}</b>
                {messages.paragraph2C5}
                <b>{messages.paragraph2C6}</b>
                {messages.paragraph2C7}
                <b>{messages.paragraph2C8}</b>
                {messages.paragraph2C9}
                <b>{messages.paragraph2C10}</b>
                {messages.paragraph2C11}
              </P>

              <P>
                {messages.paragraph3A}
                <a
                  href="https://unroll.me/legal/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph3B}
                </a>
                {messages.paragraph3C}
              </P>

              <P>{messages.paragraph4}</P>

              <BulletList ml2>
                <ListItem>{messages.list1Point1}</ListItem>

                <ListItem>{messages.list1Point2}</ListItem>

                <ListItem>{messages.list1Point3}</ListItem>

                <ListItem>{messages.list1Point4}</ListItem>
              </BulletList>

              <P b>{messages.paragraph5}</P>

              <P>{messages.paragraph6}</P>

              <P b>{messages.paragraph7}</P>

              <P>
                {messages.paragraph8A}
                <a
                  href="/legal/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph8B}
                </a>
                {messages.paragraph8C}
              </P>

              <BulletList ml2>
                <ListItem>{messages.list2Point1}</ListItem>

                <ListItem>{messages.list2Point2}</ListItem>

                <ListItem>{messages.list2Point3}</ListItem>
              </BulletList>

              <P>
                {messages.paragraph9A}
                <a
                  href="https://unroll.me/legal/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph9B}
                </a>
                {messages.paragraph9C}
              </P>

              <P><u>{messages.paragraph10A}</u>{messages.paragraph10B}</P>

              <P b>{messages.paragraph11}</P>

              <P>{messages.paragraph12}</P>

              <BulletList ml2>
                <ListItem>{messages.list3Point1}</ListItem>

                <ListItem>{messages.list3Point2}</ListItem>

                <ListItem>{messages.list3Point3}</ListItem>

                <ListItem>{messages.list3Point4}</ListItem>

                <ListItem>{messages.list3Point5}</ListItem>
              </BulletList>

              <P>{messages.paragraph13}</P>

              <P><u>{messages.paragraph14A}</u>{messages.paragraph14B}</P>

              <P b>{messages.paragraph15}</P>

              <P>{messages.paragraph16}</P>

              <BulletList ml2>
                <ListItem>
                  <b>{messages.list4Point1A}</b>
                  {messages.list4Point1B}
                  <a
                    href="https://nielseniq.com/global/en/legal/gdpr-operating-entities/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {messages.list4Point1C}
                  </a>
                  {messages.list4Point1D}
                  <a
                    href="https://www.gfk.com/entity-list"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {messages.list4Point1E}
                  </a>
                  {messages.list4Point1F}
                  <b>{messages.list4Point1G}</b>
                </ListItem>

                <ListItem>
                  <b>{messages.list4Point2A}</b>
                  {messages.list4Point2B}
                  <a
                    href="https://unroll.me/legal/privacy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {messages.list4Point2C}
                  </a>
                  {messages.list4Point2D}
                </ListItem>

                <ListItem>
                  <b>{messages.list4Point3A}</b>
                  {messages.list4Point3B}
                </ListItem>

                <ListItem>
                  <b>{messages.list4Point4A}</b>
                  {messages.list4Point4B}
                </ListItem>
              </BulletList>

              <P b>{messages.paragraph17}</P>

              <P>{messages.paragraph18}</P>

              <BulletList ml2>
                <ListItem>
                  <b>{messages.list5Point1A}</b>
                  {messages.list5Point1B}
                </ListItem>

                <ListItem>
                  <b>{messages.list5Point2A}</b>
                  {messages.list5Point2B}
                </ListItem>

                <ListItem>
                  <b>{messages.list5Point3A}</b>
                  {messages.list5Point3B}
                </ListItem>
              </BulletList>

              <P>
                {messages.paragraph19A}
                <a
                  href="/legal/privacy/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph19B}
                </a>
                {messages.paragraph19C}
                <a
                  href="https://privacyportal-eu.onetrust.com/webform/07a2e8c2-346a-4f58-865f-0d56c9baaff5/9d706729-b350-4c79-abce-eae223c1cb52"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph19D}
                </a>
                {messages.paragraph19E}
                <a href="mailto:privacy@unroll.me">{messages.paragraph19F}</a>.
              </P>

              <P>
                {messages.paragraph20A}
                <a href="mailto:privacy@unroll.me">{messages.paragraph20B}</a>
                {messages.paragraph20C}
                <a
                  href="http://www.atg.wa.gov/file-complaint"
                  target="_blank"
                  rel="noreferrer"
                >
                  {messages.paragraph20D}
                </a>
                .
              </P>
            </Wrapper>
          </Section>
        </Hero>
      </Layout>
    )
  }
}

export default injectIntl(Privacy)
